/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-PIM Management API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { PimFeedbackRestDto } from '../models';
import { TextFragmentRestDto } from '../models';
/**
 * PIMFeedbackAPIApi - axios parameter creator
 * @export
 */
export const PIMFeedbackAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint responsible for creating feedback about pim information of a product.
         * @summary REST.API.PIM.PR.02 Create pim feedback
         * @param {PimFeedbackRestDto} body 
         * @param {number} cnk_code The product CNK code that uniquely identifies the product.
         * @param {string} language_code The language in which the product info is requested.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPimFeedback: async (body: PimFeedbackRestDto, cnk_code: number, language_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPimFeedback.');
            }
            // verify required parameter 'cnk_code' is not null or undefined
            if (cnk_code === null || cnk_code === undefined) {
                throw new RequiredError('cnk_code','Required parameter cnk_code was null or undefined when calling createPimFeedback.');
            }
            // verify required parameter 'language_code' is not null or undefined
            if (language_code === null || language_code === undefined) {
                throw new RequiredError('language_code','Required parameter language_code was null or undefined when calling createPimFeedback.');
            }
            const localVarPath = `/mgmt/v1/product/by_cnk/{cnk_code}/lang/{language_code}/feedback`
                .replace(`{${"cnk_code"}}`, encodeURIComponent(String(cnk_code)))
                .replace(`{${"language_code"}}`, encodeURIComponent(String(language_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint responsible for creating feedback about pim information of a product.
         * @summary REST.API.PIM.PR.05 Create pim feedback
         * @param {PimFeedbackRestDto} body 
         * @param {number} cnk_code The product CNK code that uniquely identifies the product.
         * @param {string} language_code The language in which the product info is requested.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPimFeedbackByProductCode: async (body: PimFeedbackRestDto, cnk_code: number, language_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPimFeedbackByProductCode.');
            }
            // verify required parameter 'cnk_code' is not null or undefined
            if (cnk_code === null || cnk_code === undefined) {
                throw new RequiredError('cnk_code','Required parameter cnk_code was null or undefined when calling createPimFeedbackByProductCode.');
            }
            // verify required parameter 'language_code' is not null or undefined
            if (language_code === null || language_code === undefined) {
                throw new RequiredError('language_code','Required parameter language_code was null or undefined when calling createPimFeedbackByProductCode.');
            }
            const localVarPath = `/mgmt/v1/product/{product_code}/lang/{language_code}/feedback`
                .replace(`{${"cnk_code"}}`, encodeURIComponent(String(cnk_code)))
                .replace(`{${"language_code"}}`, encodeURIComponent(String(language_code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PIMFeedbackAPIApi - functional programming interface
 * @export
 */
export const PIMFeedbackAPIApiFp = function(configuration?: Configuration) {
    return {
        /**
         * API endpoint responsible for creating feedback about pim information of a product.
         * @summary REST.API.PIM.PR.02 Create pim feedback
         * @param {PimFeedbackRestDto} body 
         * @param {number} cnk_code The product CNK code that uniquely identifies the product.
         * @param {string} language_code The language in which the product info is requested.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPimFeedback(_axios: AxiosInstance, body: PimFeedbackRestDto, cnk_code: number, language_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextFragmentRestDto>> {
            const localVarAxiosArgs = await PIMFeedbackAPIApiAxiosParamCreator(configuration).createPimFeedback(body, cnk_code, language_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * API endpoint responsible for creating feedback about pim information of a product.
         * @summary REST.API.PIM.PR.05 Create pim feedback
         * @param {PimFeedbackRestDto} body 
         * @param {number} cnk_code The product CNK code that uniquely identifies the product.
         * @param {string} language_code The language in which the product info is requested.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPimFeedbackByProductCode(_axios: AxiosInstance, body: PimFeedbackRestDto, cnk_code: number, language_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextFragmentRestDto>> {
            const localVarAxiosArgs = await PIMFeedbackAPIApiAxiosParamCreator(configuration).createPimFeedbackByProductCode(body, cnk_code, language_code, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PIMFeedbackAPIApi - object-oriented interface
 * @export
 * @class PIMFeedbackAPIApi
 * @extends {BaseAPI}
 */
export class PIMFeedbackAPIApi extends BaseAPI {
    /**
     * API endpoint responsible for creating feedback about pim information of a product.
     * @summary REST.API.PIM.PR.02 Create pim feedback
     * @param {PimFeedbackRestDto} body 
     * @param {number} cnk_code The product CNK code that uniquely identifies the product.
     * @param {string} language_code The language in which the product info is requested.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PIMFeedbackAPIApi
     */
     public createPimFeedback(body: PimFeedbackRestDto, cnk_code: number, language_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PIMFeedbackAPIApiFp(this.configuration).createPimFeedback(this.axios, body, cnk_code, language_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint responsible for creating feedback about pim information of a product.
     * @summary REST.API.PIM.PR.05 Create pim feedback
     * @param {PimFeedbackRestDto} body 
     * @param {number} cnk_code The product CNK code that uniquely identifies the product.
     * @param {string} language_code The language in which the product info is requested.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PIMFeedbackAPIApi
     */
     public createPimFeedbackByProductCode(body: PimFeedbackRestDto, cnk_code: number, language_code: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PIMFeedbackAPIApiFp(this.configuration).createPimFeedbackByProductCode(this.axios, body, cnk_code, language_code, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

}
